import { FC } from 'react';
import classNames from 'classnames';
import { WAVEFORM_BARS } from './audioLevels';

interface Props {
  // One level per bar, 0 to 1. Fewer than the bar count leaves the rest
  // flat, which is how a recording grows from the left.
  levels: number[];
  // How much of a clip has played, 0 to 1. Bars up to there are lit.
  progress?: number;
  tone: 'recording' | 'clip';
  className?: string;
}

// A row of thin bars whose heights follow the sound.
export const Waveform: FC<Props> = ({
  levels,
  progress = 0,
  tone,
  className,
}) => {
  const bars = Array.from({ length: WAVEFORM_BARS }, (_, i) => levels[i] ?? 0);
  const litCount = Math.round(progress * WAVEFORM_BARS);

  return (
    <div className={classNames(styles.row, className)} aria-hidden="true">
      {bars.map((level, i) => (
        <span
          key={i}
          className={classNames(
            styles.bar,
            tone === 'recording' && styles.recording,
            tone === 'clip' && (i < litCount ? styles.played : styles.clip),
          )}
          style={{ height: `${4 + Math.round(level * 18)}px` }}
        />
      ))}
    </div>
  );
};

const styles = {
  row: 'flex h-6 min-w-0 flex-1 items-center gap-[3px] overflow-hidden',
  bar: 'w-[3px] shrink-0 rounded-full transition-[height] duration-100',
  recording: 'bg-mf-red-400',
  clip: 'bg-accent-ink/35',
  played: 'bg-accent-ink',
};
